/**
 * Toggle to enable multimodal query product search
 */ export var ENABLE_MULTIMODAL_QUERY_PRODUCT_SEARCH_250220 = 'ENABLE_MULTIMODAL_QUERY_PRODUCT_SEARCH_250220';
